var module = angular.module('octopusApp.configuration');

module.controller('UserRoleEditController', function($scope, $stateParams, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    var roleId = $stateParams["id"];

    $scope.team = null;
    $scope.availablePermissions = [];
    $scope.title = null;

    var buildAvailable = function(permissionDescriptions) {
        $scope.availablePermissions = _.chain(permissionDescriptions).map(function (d, k) {
            return {
                id: k,
                description: d.Description,
                selected: $scope.role.GrantedPermissions.indexOf(k) >= 0
            };
        }).sortBy("id").value();
    };

    isLoading.promise(octopusRepository.PermissionDescriptions.all().then(function (permissionDescriptions) {
        if (roleId) {
            isLoading.promise(octopusRepository.UserRoles.get(roleId).then(function (result) {
                $scope.role = result;
                $scope.role.CanBeRenamed = result.CanbeDeleted;
                pageTitle($scope.role.Name);
                $scope.title = $scope.role.Name;
                buildAvailable(permissionDescriptions);
            }));
        } else {
            $scope.role = { Id: null, Name: '', CanBeRenamed: true, CanBeDeleted: false, GrantedPermissions: [] };
            pageTitle("Create custom role");
            $scope.title = "Create custom role";
            buildAvailable(permissionDescriptions);
        }
    }));

    $scope.save = function() {
        $scope.role.GrantedPermissions = _.chain($scope.availablePermissions).filter(function (p) {
            return p.selected;
        }).map(function (p) {
            return p.id;
        }).value();

        isSaving.promise(octopusRepository.UserRoles.save($scope.role).then(function (result) {
            unsavedChanges.saved();
            $location.path("/configuration/roles");
        }));
    };

  $scope.togglePermission = function (perm) {
    if (perm.id.endsWith("Edit") || perm.id.endsWith("EditUnscoped")) {
      var viewPerm_ = findMatchingPerm(perm, "Edit", "View")
      if (viewPerm_ && perm.selected) {
        if (viewPerm_) {
          viewPerm_.selected = true;
        }
      }
      return;
    }

    if (perm.id.endsWith("Delete") || perm.id.endsWith("DeleteUnscoped")) {
      var viewPerm = findMatchingPerm(perm, "Delete", "View")
      if (viewPerm && perm.selected) {
        if (viewPerm) {
          viewPerm.selected = true;
        }
      }
      return;
    }
  }

  $scope.isPermissionDisabled = function (perm) {
    if (!perm.id.endsWith("View") && !perm.id.endsWith("ViewUnscoped")) {
      return false;
    }

    var editPerm = findMatchingPerm(perm, "View", "Edit");
    if (editPerm && editPerm.selected) {
      return true;
    }

    var deletePerm = findMatchingPerm(perm, "View", "Delete");
    if (deletePerm && deletePerm.selected) {
      return true;
    }

    return false;
  }

  var findMatchingPerm = function (perm, input, output) {
    if (perm.id.endsWith(input)) {
      var viewPermName = perm.id.substr(0, perm.id.length - input.length) + output;
      var viewPerm = _.find($scope.availablePermissions, function (x) {
        return x.id === viewPermName
      });
      return viewPerm;
    }
    if (perm.id.endsWith(input + "Unscoped")) {
      var viewPermName = perm.id.substr(0, perm.id.length - input.length - "Unscoped".length) + output + "Unscoped";
      var viewPerm = _.find($scope.availablePermissions, function (x) {
        return x.id === viewPermName
      });
      return viewPerm;
    }
    return undefined;
  }

  $scope.requiredTooltip = function (perm) {
    if (!$scope.isPermissionDisabled(perm)) {
      return undefined;
    }
    var editPerm = findMatchingPerm(perm, "View", "Edit");
    var deletePerm = findMatchingPerm(perm, "View", "Delete");
    if (editPerm && editPerm.selected && deletePerm && deletePerm.selected) {
      return perm.id + " is required because " + editPerm.id + " and " + deletePerm.id + " are selected";
    }
    if (editPerm && editPerm.selected) {
      return perm.id + " is required because " + editPerm.id + " is selected";
    }
    if (deletePerm && deletePerm.selected) {
      return perm.id + " is required because " + deletePerm.id + " is selected";
    }
    return undefined;
  };
});










//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/roles/controllers/user_role_edit_controller.js
// module id = 6378277924642988
// module chunks = 1